export default {
  splitNumber: 3,
  name: {
    color: '#666'
  },
  itemStyle: {
    normal: {
      borderWidth: '1'
    }
  },
  lineStyle: {
    normal: {
      width: '2'
    }
  },
  axisLine: {
    show: true,
    lineStyle: {
      color: '#EEEEEE'
    }
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: '#EEEEEE'
    }
  },
  splitArea: {
    areaStyle: {
      color: ['transparent']
    }
  },
  symbolSize: '5',
  symbol: 'circle',
  smooth: true
};